'use client'

import type { SwitcherListProps } from '@maestro/commerce-blocks/components/switcher/switcher.types'

import classNames from 'classnames'

export default function SwitcherList(props: SwitcherListProps) {
  const { children, className } = props

  return <ul className={classNames('switcher__list', className)}>{children}</ul>
}
